import { MetaReducer, Action, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';

import { DatasetService } from './service/dataset.service';
import { DatasetsEffects } from './state/effects/datasets.effects';
import { DatasetsReducer, DatasetsState } from './state/reducers/datasets.reducer';
import { datasetsStateKey } from './state';
import { DatasetsFacade } from './facade/datasets.facade';

const localStorageSyncReducer = createLocalStorageSyncReducer<DatasetsState>(['selectDataset']);

const metaReducers: Array<MetaReducer<DatasetsState, Action>> = [localStorageSyncReducer];

export const datasetsConfig = [
  provideState(datasetsStateKey, DatasetsReducer, { metaReducers }),
  provideEffects([DatasetsEffects]),
  DatasetsFacade,
  DatasetService,
];
